var React = require('react');

function BtnAInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_1188","data-name":"Path 1188","d":"M4438.51,308.485a1,1,0,0,1,0-1.414l13.85-13.849h-8.9a1,1,0,0,1,0-2h11.32a1,1,0,0,1,1,1v11.313a1,1,0,0,1-2,0v-8.9l-13.85,13.849A1.007,1.007,0,0,1,4438.51,308.485Z","transform":"translate(-4438.218 -291.222)","fill":"#fff","fillRule":"evenodd"}));
}

BtnAInline.defaultProps = {"width":"17.562","height":"17.556","viewBox":"0 0 17.562 17.556"};

module.exports = BtnAInline;

BtnAInline.default = BtnAInline;
